// @ts-nocheck
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Home from "./Home";
import Alias from "../Alias/Alias";
import { PrivateRoute } from "../Auth/PrivateRoute";
import { PrivateRouteFiliacion } from "../Auth/PrivateRouteFiliacion";
import { Difusiones } from "../Difusiones/Difusiones";
import { Areas } from "../Areas/Areas";
import AlertFalloServidor from "../Componentes/AlertFalloServidor";
import Desuscripcion from "./Desuscripcion";
import {
  ACCESO_ALIAS,
  ACCESO_DIFUSIONES,
  ACCESO_RECIBOS,
  ACCESO_AREAS,
  ACCESO_BUSCADOR_INTERNOS,
  ACCESO_USUARIOS,
  ACCESO_AGENDA,
  ACCESO_WIFI_PRIVADO,
  ACCESO_ALTA_USUARIOS,
  ACCESO_TRADUCTOR,
  ACCESO_ADMIN_TRADUCCIONES,
  ACCESO_VER_ROLES,
  ACCESO_VPN,
  ACCESO_SUELDOS,
} from "../Contantes/Constantes";
import Notices from "./Notices";
import { Ticketera } from "../Ticketera/Ticketera";
import Recibo from "../Recibos/Recibo";
import AlertInfo from "../Componentes/AlertInfo";
import AlertSuccess from "../Componentes/AlertSuccess";
import { AltaUsuarios } from "../Usuarios/AltaUsuarios";
import { Finalizado } from "../Usuarios/Finalizado";
import { FormularioSolicitud } from "../Usuarios/FormularioSolicitud";
import GestionarUsuario from "../Usuarios/GestionarUsuario";
import { ProvideDifusiones } from "../Difusiones/context/DifusionesContext";
import { ProvideUsuarios } from "../Usuarios/State/ProvideUsuarios";
import { ProvideFormulario } from "../Usuarios/State/FormularioState/ProvideFormulario";
import { ProvideAreas } from "../Areas/State/ProvideAreas";
import { TranslationProvider } from "../Traducciones/translationContext";
import { VerRolesProvider } from "../Roles/verRolesContext";
import ResetPassword from "../Usuarios/ResetPassword";
import { Agenda } from "../Areas/Agenda/Agenda";
import TraduccionesSolicitante from "../Traducciones/pages/TraduccionesSolicitante";
import TraduccionesTraductor from "../Traducciones/pages/TraduccionesTraductor";
import TraduccionesAdmin from "../Traducciones/pages/TraduccionesAdmin";
import VerRoles from "../Roles/pages/VerRoles";
import WifiPublico from "../Wifi/pages/WifiPublico";
import WifiPrivado from "../Wifi/pages/WifiPrivado";
import WifiInvitados from "../Wifi/pages/WifiInvitados";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import BackdropGeneral from "../Componentes/BackdropGeneral";
import Footer from "./Footer";
import Credencial from "../Credencial/Credencial";
import Constancia from "../Credencial/Constancia";
import ModuloVPN from "../VPN/ModuloVPN";
import Archivos from "../Archivos/Archivos";
import SolicitudActiveDirectory from "../Usuarios/SolicitudActiveDirectory";
import BuscadorInternos from "../Alias/Componentes/BuscadorInternos";
import Sueldos from "../Sueldos/Sueldos";
import ChatBot from "../ChatBot/ChatBot"

// Define styled components
const MainStyled = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  flexGrow: 1,
}));

const ToolbarStyled = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  ...theme.mixins.toolbar,
}));

const ContentStyled = styled("div")(({ theme }) => ({
  padding: "1.25%",
  [theme.breakpoints.down("sm")]: {
    padding: 0,
  },
}));

export default function Body() {
  return (
    <MainStyled>
      <ToolbarStyled />
      <Switch>
        <Route exact path="/">
          <ContentStyled>
            <Home error={false} />
          </ContentStyled>
        </Route>
        <Route exact path="/desuscripcion/:mensaje/:severity">
          <ContentStyled>
            <Desuscripcion />
          </ContentStyled>
        </Route>
        <Route exact path="/usuarios/finalizado">
          <ContentStyled>
            <Finalizado />
          </ContentStyled>
        </Route>
        <Route exact path="/usuarios/formulario">
          <ContentStyled>
            <FormularioSolicitud />
          </ContentStyled>
        </Route>
        <Route exact path="/usuarios/recuperar/contraseña">
          <ContentStyled>
            <ResetPassword />
          </ContentStyled>
        </Route>
        <Route exact path="/usuarios/recuperar/contraseña">
          <ContentStyled>
            <ResetPassword />
          </ContentStyled>
        </Route>
        {/*  <Route exact path="/wifi/publico">
                    <WifiPublico />
                </Route> */}
        <PrivateRoute path="/traducciones/solicitante">
          <TranslationProvider>
            <TraduccionesSolicitante />
          </TranslationProvider>
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_TRADUCTOR} path="/traducciones/traductor">
          <TranslationProvider>
            <TraduccionesTraductor />
          </TranslationProvider>
        </PrivateRoute>
        <PrivateRoute
          roles={ACCESO_ADMIN_TRADUCCIONES}
          path="/traducciones/admin"
        >
          <TranslationProvider>
            <TraduccionesAdmin />
          </TranslationProvider>
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_VER_ROLES} path="/usuarios/roles">
          <VerRolesProvider>
            <ProvideAreas>
              <VerRoles />
            </ProvideAreas>
          </VerRolesProvider>
        </PrivateRoute>
        <Route exact path="/usuarios/solicitudAD">
          <SolicitudActiveDirectory />
        </Route>
        <PrivateRoute exact path="/buscador/interno">
          <ProvideAreas>
            <BuscadorInternos />
          </ProvideAreas>
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_ALIAS} path="/alias">
          <Alias />
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_DIFUSIONES} path="/difusiones">
          <ProvideDifusiones>
            <Difusiones />
            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                backgroundColor: "#ffffff",
              }}
            >
              <p>
                El módulo de difusiones se encuentra momentáneamente
                inhabilitado. Disculpe las molestias ocasionadas.
              </p>
            </div> */}
          </ProvideDifusiones>
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_SUELDOS} path="/sueldos">
          <ContentStyled>
            <Sueldos />
          </ContentStyled>
        </PrivateRoute>
        <PrivateRoute path="/noticias">
          <ContentStyled>
            <Notices time={500} />
          </ContentStyled>
        </PrivateRoute>
        <PrivateRouteFiliacion filiacionNegada={"Alumno"} path="/ticketera">
          <ContentStyled>
            <Ticketera />
          </ContentStyled>
        </PrivateRouteFiliacion>
        <PrivateRoute roles={ACCESO_RECIBOS} path="/recibos">
          <ContentStyled>
            <Recibo />
          </ContentStyled>
        </PrivateRoute>
        {/*  <PrivateRoute path="/wifi/invitados">
                    <WifiInvitados />
                </PrivateRoute> */}
        {/* <PrivateRoute roles={ACCESO_WIFI_PRIVADO} path="/wifi/privado">
                    <WifiPrivado />
                </PrivateRoute> */}
        <PrivateRoute roles={ACCESO_AREAS} path="/areas">
          <Areas />
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_VPN} path="/vpn">
          <ModuloVPN />
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_AGENDA} path="/agenda">
          <ContentStyled>
            <Agenda />
          </ContentStyled>
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_ALTA_USUARIOS} path="/usuarios/alta">
          <AltaUsuarios />
        </PrivateRoute>
        <PrivateRoute roles={ACCESO_USUARIOS} path="/usuarios/gestion">
          <ProvideUsuarios>
            <ProvideFormulario>
              <ContentStyled>
                <GestionarUsuario />
              </ContentStyled>
            </ProvideFormulario>
          </ProvideUsuarios>
        </PrivateRoute>
        <PrivateRoute exact path="/credencial">
          <ContentStyled>
            <Credencial />
          </ContentStyled>
        </PrivateRoute>
        <Route path="/constancia/:data_alumno">
          <ContentStyled>
            <Constancia />
          </ContentStyled>
        </Route>
        <PrivateRoute exact path="/sec_administrativa">
          <ContentStyled>
            <Archivos />
          </ContentStyled>
        </PrivateRoute>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
      <Footer />
      <AlertFalloServidor />
      <AlertInfo />
      <AlertSuccess />
      <BackdropGeneral />
    </MainStyled>
  );
}
